<!-- 新建活动 -->
<template>
  <div class="wrapper" ref="wrapper">
    <div class="header-wrapper">
      <!-- 返回按钮 -->
      <div class="iconfont icon-fanhui2 left" @click="back"></div>
      <!-- 标题 -->
      <div class="header">{{ header }}活动</div>
      <!-- 按钮组 -->
      <div class="addManager">
        <Button class="bkcc-btn" @click="templateShow.value = true">选择模板</Button>
        <Button
          class="bkcc-btn"
          @click="newActivity('0')"
          :loading="isSaveCaogao"
          v-if="!isFromDetail"
        >保存草稿</Button>
        <Button class="bkcc-btn" @click="newActivity('1')" :loading="isSaveSend">发布</Button>
      </div>
    </div>
    <div class="editview box">
      <!-- 左侧表单框 -->
      <div class="editform box box_v">
        <div style="margin-bottom: 30px">
          <upload-img
            :imgArr="imgArr"
            :imgNumber="imgNumber"
            :fixedNumber="fixedNumber"
            :imgHeight="325"
            :imgWidth="520"
            @delPic="delPic"
            @saveImg="saveImg"
            :isActive="isActive"
          >
            <div class="uploadbox">
              <div class="iconfont icon-shangchuan1 add"></div>
              <div class="tr1">请上传海报</div>
              <div class="tr2">注意图片尺寸为8：5，图片大小不超过2M</div>
            </div>
          </upload-img>
        </div>
        <Form ref="formInline" label-position="top">
          <FormItem label="主办方" prop="host">
            <Select v-model="zhuban">
              <Option
                v-for="(item, index) in zhubanList"
                :value="item.id"
                :key="index"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <div class="box">
            <FormItem label="联系人" style="width:190px;margin-right:30px;">
              <Input v-model="lianxiren" placeholder="请输入..." />
            </FormItem>
            <FormItem label="电话" class="box_f1">
              <!-- @on-blur="checkMobile(dianhua)" -->
              <Input v-model="dianhua" placeholder="请输入..." />
            </FormItem>
          </div>
          <FormItem label="地点">
            <div v-if="didian" class="address" @click="showmap()">{{ didian }}</div>
            <div v-else @click="showmap()" class="address address_nodata">请选择地点</div>
            <map-modal v-if="showMap" @confirm="getAddress" @cancel="showmap" :zuobiao="zuobiao"></map-modal>
          </FormItem>

          <FormItem label="发布至">
            <CheckboxGroup v-model="joinPeople">
              <Checkbox
                :label="item.id"
                v-for="item in joinList"
                :key="item.id"
                :disabled="bmDisabled"
              >
                <span>{{ item.name }}</span>
              </Checkbox>
            </CheckboxGroup>
          </FormItem>

          <div class="box">
            <FormItem label="上限人数" style="width: 190px;margin-right: 30px">
              <Input type="number" v-model="shangxian" placeholder="请输入..." />
            </FormItem>
            <FormItem label="积分" class="box_f1">
              <Select v-if="scoreList && scoreList.length > 0" v-model="jifen" :disabled="jfDisabled" style="width:100%">
                <Option v-for="(item, index) in scoreList" :value="item.value" :key="index">{{ item.label }}</Option>
              </Select>
              <Input v-else v-model="jifen" placeholder="请输入..." :disabled="jfDisabled" />
            </FormItem>
          </div>

          <FormItem label="开始时间">
            <div class="box">
              <DatePicker
                type="date"
                placeholder="请选择日期"
                v-model="startDate"
                style="width:310px;margin-right:30px"
              ></DatePicker>
              <TimePicker type="time" placeholder="请选择时间" v-model="startTime" style="width:180px"></TimePicker>
            </div>
          </FormItem>
          <FormItem label="结束时间">
            <div class="box">
              <DatePicker
                type="date"
                placeholder="请选择日期"
                v-model="endDate"
                style="width:310px;margin-right:30px"
              ></DatePicker>
              <TimePicker type="time" placeholder="请选择时间" v-model="endTime" style="width:180px"></TimePicker>
            </div>
          </FormItem>
          <FormItem label="分类">
            <classify
              :arr="fenleiList"
              @addFenlei="addFenlei"
              @delFenlei="delFenlei"
              @selectFenlei="selectFenlei"
            ></classify>
          </FormItem>
          <FormItem>
            <label for>
              时长
              <i style="color: #999">（用来统计参与者实际参与活动时长，非必填）</i>
            </label>
            <div class="box">
              <Input
                type="number"
                v-model="timeLength"
                style="max-width: 278px"
                placeholder="请输入..."
              />
              <p class="ptishi box" style="margin-left:30px;color:#999">小时</p>
            </div>
          </FormItem>
          <FormItem label="提醒">
            <div class="box">
              <Select v-model="tixingId" placeholder="请选择" class="box_f1">
                <Option
                  v-for="(item, index) in tixing"
                  :value="item.val"
                  :key="index"
                >{{ item.text }}</Option>
              </Select>
              <p class="ptishi box" style="margin-left:30px;color:#999">参与活动的人会在活动前收到提醒</p>
            </div>
          </FormItem>
          <FormItem label="关联问卷">
            <div class="box">
              <Select 
                v-model="voteId" 
                placeholder="请选择"
                class="box_f1" 
                filterable 
                :remote-method="remoteMethod1"
                :loading="loading1" 
                clearable>
                <Option
                  v-for="(item, index) in options1"
                  :value="item.value"
                  :key="index"
                >{{ item.label }}</Option>
              </Select>
              <p class="ptishi box" style="margin-left:30px;color:#999"></p>
            </div>
          </FormItem>
        </Form>
      </div>
      <!-- 右侧富文本编辑 -->
      <div class="editbox box_f1" ref="editview">
        <editor-box
          :height="editorHeight"
          @editorContent="activityContent"
          :content="lastContent"
     
        >
          <div class="editslotbox">
            <textarea
              placeholder="请在这里输入标题"
              :value="title"
              class="activitytitle"
              @input="titleinputchange"
              maxlength="64"
            ></textarea>
            <div class="titlenumber">{{ titleNumber }}/64</div>
          </div>
        </editor-box>
      </div>
    </div>
    <!-- 弹窗 -->
    <activity-template :show="templateShow" @on-ok="onTemplateChange"></activity-template>
  </div>
</template>

<script>
import uploadImg from "../../../components/uploadImg";
import editorBox from "../../../components/editorBox";
import classify from "../components/classify";
import activityTemplate from "../components/activityTemplate";
import mapModal from "../../../components/mapModal";

export default {
  components: {
    uploadImg,
    editorBox,
    classify,
    mapModal,
    activityTemplate
  },
  data() {
    // 这里存放数据
    return {
     
      id: "",
      isFromDetail: 0, // 从活动详情进入可编辑活动
      imgNumber: 1,
      imgArr: [],
      options1: [],
      voteId:'',
      fixedNumber: [8, 5],
      content: "ceshiceshiceshi",
      formItem: {
        select: "NewYork",
        input: "NewYork"
      },
      ruleValidate: [],
      title: "", // 活动标题
      titleNumber: 0, // 活动字数
      fenleiList: [], // 分类集合
      zhubanList: [], // 主办方集合
      zhuban: "", // 主办方id
      lianxiren: "", // 联系人名字
      dianhua: "", // 电话
      didian: "", // 地点
      shangxian: "", // 上限人数
      jifen: "", // 积分
      startDate: "", // 开始日期
      startTime: "", // 开始时间
      endDate: "", // 结束日期
      endTime: "", // 结束时间
      editorHeight: "100%",
      tixing: [
        { text: "提前1天提醒", val: "1" },
        { text: "提前2天提醒", val: "2" },
        { text: "提前3天提醒", val: "3" }
      ], // 提醒列表
      tixingId: "", // 选择的提醒
      actcontent: "",
      zuobiao: {},
      isActive: false,
      isSaveCaogao: false, // 控制保存草稿按钮的loading
      isSaveSend: false, // 控制发送按钮的loading
      routerState: "",
      caogaoContent: "",
      lastContent: "", // 保存的草稿内容
      caogaoType: "",
      moren: "",
      str: "",
      center: [116.66517, 39.90575],
      showMap: false,
      addressList: [], // 联想搜索 地址列表
      joinPeople: [], // 参与人
      joinList: [
        {
          id: "xfej",
          name: "先锋e家"
        },
        {
          id: "mst",
          name: "民生通"
        }
      ],
      signTotal: "",
      jfDisabled: false,
      loading1: false,
      bmDisabled: false,
      header: "",
      timeLength: "",
      // 是否显示模板弹窗
      templateShow: {
        value: false
      },
      scoreList:[]
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    caogaoType(val) {
      setTimeout(() => {
        for (var i = 0; i < this.fenleiList.length; i++) {
          if (this.fenleiList[i].name == val) {
            this.fenleiList[i].isSelected = true;
          }
        }
      }, 300);
    }
  },
  // 方法集合
  methods: {

    // 获取积分
    getScore() {
      try{
        var url = this.urlobj.GetCodeByTypeforPhone;
        this.$get(url, {
          typeName:"huodongjifen"
        }).then(res => {
          this.scoreList = res.rows.map(item=>{
            return{
              value:Number(item.domain)/100,
              label:item.name,
            }
          })
        });
      } catch (e) {
        console.log(e);
      }
    },
    remoteMethod1 (query) {
        this.loading1 = true;
        var url = this.urlobj.getVoteList;
        this.$post(url, {
          "title":query,
          "pageNum": 1,
          "pageSize": 20
        })
        .then(res => {
          if(res.isSucceed){
            var list = res.rows.map(item => {
              return {
                label: item.title,
                value: item.id
              };
            });
            this.options1 = list;
          }else{
            this.$Message.error(res.message);
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading1 = false;
        });
    },
    onTemplateChange(cur) {
      this.getcaogao(cur.id);
    },
    getcaogao(id) {
      var that = this;
      this.$get(this.urlobj.getActiveDetail(id)).then(res => {
        var data = res.rows[0];
        this.title = data.title;
        this.titleNumber = data.title.length;
        this.zhuban = data.organizerList.length
          ? data.organizerList[0].comeId
          : "";
        this.lianxiren = data.userName;
        this.dianhua = data.phoneNO;
        this.didian = data.address;
        this.shangxian = data.limitNumber;
        this.startDate = data.beginTime
          ? this.$util.FormatDate(Number(data.beginTime), "yyyy-MM-dd")
          : "";
        this.startTime = data.beginTime
          ? this.$util.FormatDate(Number(data.beginTime), "HH:mm:ss")
          : "";
        this.endDate = data.endTime
          ? this.$util.FormatDate(Number(data.endTime), "yyyy-MM-dd")
          : "";
        this.endTime = data.endTime
          ? this.$util.FormatDate(Number(data.endTime), "HH:mm:ss")
          : "";
        this.caogaoContent = data.context ? data.context : "";
        this.lastContent = data.context ? data.context : "";
        this.jifen = data.score ? data.score / 100 : 0;
        this.caogaoType = data.labelNameList ? data.labelNameList : "";
        this.timeLength = data.timeLength ? data.timeLength / 3600 / 1000 : "";
        if (data.coverPicUrl) {
          this.imgArr[0] = {
            path: data.coverPicUrl
          };
        }
        this.isActive = data.coverPicUrl ? true : false;
        this.joinPeople = data.appTypeList;
        if (data.coordinate) {
          var reg = /[0-9]+.[0-9]+/g;
          var xy = data.coordinate.match(reg);
          that.zuobiao.value = xy.join(",");
          that.zuobiao.label = data.address;
        }
        this.tixingId = data.remindBefore.toString();
        this.fromWhere = data.appTypeList;
        let isSend = data.isSend;
        // 只有存在全局id的时候认为为草稿或再编辑
        this.id && this.getSign(id, data.appTypeList, isSend);
        this.id && this.getBaoming(id, data.appTypeList, isSend);
      });
    },
    saveImg(data) {
      this.imgArr.splice(0, 1, data);
      this.isActive = true;
    },
    getSign(id, appTypeList, isSend) {
      this.$post(this.urlobj.getActivityPeople, {
        id: id,
        pageNum: 1,
        pageSize: 30,
        recordType: "sign",
        appTypeList: appTypeList
      }).then(res => {
        this.signTotal = res.total;
        if (res.total !== 0 && isSend == 1) {
          this.jfDisabled = true;
        }
      });
    },
    getBaoming(id, appTypeList, isSend) {
      this.$post(this.urlobj.getActivityPeople, {
        id: id,
        pageNum: 1,
        pageSize: 30,
        recordType: "apply",
        appTypeList: appTypeList
      }).then(res => {
        this.signTotal = res.total;
        if (res.total !== 0 && isSend == 1) {
          this.bmDisabled = true;
        }
      });
    },
    back() {
      if (this.isFromDetail == 1) {
        this.$router.push({ name: "activitydetail", query: { id: this.id } });
      } else {
        var state = "";
        if (this.routerState == 1) {
          state = 0;
        } else if (this.routerState == 0) {
          state = 1;
        } else if (this.routerState == "org") {
          this.$router.go(-1);
          return;
        }
        this.$router.push({ name: "activitylist", query: { state } });
      }
    },
    checkMobile(str) {
      if (str.substring(0, 1) == 1) {
        let re = /^1\d{10}$/;
        if (!re.test(str)) return this.$Message.warning("电话格式不正确!");
      } else if (str.substring(0, 1) == 0) {
        let re = /^0\d{2,3}-?\d{7,8}$/;
        if (re.test(str)) return this.$Message.warning("电话格式不正确!");
      } else {
        let re = /^(\d{7,8})(-(\d{3,}))?$/;
        if (re.test(str)) return this.$Message.warning("电话格式不正确!");
      }
    },
    titleinputchange(e) {
      // 输入标题
      this.titleNumber = e.target.value.length;
      this.title = e.target.value;
    },
    ditus(data) {
      this.x = data.value ? data.value : ",";
      this.y = data.label;
    },
    delPic(data) {
      // 删除封面图
      var id = data.id;
      var url = this.urlobj.deletePic(id);
      this.$delete(url).then(res => {
        if (res.isSucceed) {
          this.$Message.success("删除成功");
          this.imgArr = [];
        }
      });
    },
    getZhuban() {
      var url = this.urlobj.getZhuban;
      // let data = {
      //   zoneType: -1,
      //   isAddCommunity: 1,
      //   communityId: this.$store.state.streetorcommunityid
      // };
      this.$get(url).then(res => {
        this.zhubanList = res.rows.map(item => {
          return {
            id: item.comeId,
            name: item.name,
            comeType: item.comeType
          };
        });
      });
    },
    getactive() {
      // 获取分类
      var that = this;
      var url = this.urlobj.getfenlei;
      this.$get(url).then(function(res) {
        that.fenleiList = res.rows.map(item => {
          return {
            name: item.name,
            id: item.id,
            isSelected: false
          };
        });
      });
    },
    selectFenlei(selectindex) {
      this.fenleiList.forEach((item, index) => {
        item.isSelected = false;
        if (selectindex == index) {
          item.isSelected = true;
        }
      });
    },
    addFenlei(name) {
      // 添加分类
      var list = this.fenleiList;
      for (var i = 0; i < list.length; i++) {
        if (list[i].name == name) {
          this.$Message.warning("分类不能重复!");
          return;
        }
      }
      if (name == "") {
        this.$Message.warning("分类不能为空!");
        return;
      }
      var url = this.urlobj.addLabel();
      this.$post(url, {
        labelType: 3, //  1--市民分类、2--社工组织、3--活动、4--企业服务类型标签,
        name: name
      }).then(res => {
        var obj = {};
        obj.name = name;
        obj.id = res.newPrimaryKeys.id;
        obj.isSelected = false;
        this.fenleiList.push(obj);
      });
    },
    delFenlei(data) {
      // 删除分类
      var url = this.urlobj.delLabel(data.id);
      this.$delete(url).then(res => {
        if (res.isSucceed) {
          this.fenleiList.splice(data.index, 1);
        }
      });
    },
    activityContent(data) {
      // 接收富文本中的内容
      this.actcontent = data;
      this.caogaoContent = data;
    },
    // hidemap(){
    //   this.showMap = "none";
    // },
    showmap() {
      this.showMap = !this.showMap;
    },
    getAddress(val) {
      this.zuobiao = val;
      this.didian = val.label;
      this.coordinate = val.value;
      this.showmap();
    },
    // 新建活动 或者 保存草稿
    newActivity(state) {
      // 新建、保存活动
      var that = this;
      var data = {};
      // 处理选择的地点
      if (that.zuobiao.value) {
        var zuobiao = that.zuobiao.value.split(",");
        data.coordinate = '{"x":"' + zuobiao[0] + '","y":"' + zuobiao[1] + '"}';
      }
      // 发布必填的
      var activitytype = []; // 选择了的分类的id
      for (var i = 0; i < that.fenleiList.length; i++) {
        if (that.fenleiList[i].isSelected) {
          activitytype.push(that.fenleiList[i].id);
        }
      }
      if (state == 1) {
        if (that.imgArr.length == 0) {
          this.$Message.warning("请上传海报!");
          return;
        }
        if (!that.zuobiao.value) {
          this.$Message.warning("请选择活动地点!");
          return;
        }
        if (
          that.startDate == "" ||
          that.startTime == "" ||
          that.endDate == "" ||
          that.endTime == ""
        ) {
          this.$Message.warning("请填写开始或结束时间!");
          return;
        }
        if (!that.lianxiren) {
          this.$Message.warning("请填写联系人!");
          return;
        }
        if (!that.dianhua) {
          this.$Message.warning("请填写联系人电话!");
          return;
        }
        if (!that.joinPeople.length) {
          this.$Message.warning("请选择要发布到的小程序!");
          return;
        }
        if (!that.shangxian) {
          this.$Message.warning("请填写上限人数!");
          return;
        }
        if (!that.jifen) {
          this.$Message.warning("请填写积分!");
          return;
        }
        if (!that.title || !that.actcontent) {
          this.$Message.warning("请完善活动信息！");
          return;
        }
        if (that.timeLength && that.timeLength <= 0) {
          this.$Message.warning("请填写正确的时长！");
          return;
        }
        if (activitytype.length == 0) {
          this.$Message.warning("请选择分类！");
          return;
        }
      }
      // 保存发布都需要的
      if (that.title.length > 64) {
        this.$Message.warning("标题不能超过64个字！");
        return;
      }
      // 活动的 开始结束 时间校验  开始时间不能小于当前时间 结束时间不能小于开始时间
      // let _now = Date.now();
      let _beginTime = new Date(
        `${that.$util.FormatDate(that.startDate.valueOf(), "yyyy-MM-dd")} ${
          that.startTime
        }`
      ).getTime();
      let _endTime = new Date(
        `${that.$util.FormatDate(that.endDate.valueOf(), "yyyy-MM-dd")} ${
          that.endTime
        }`
      ).getTime();
      // if (_beginTime < _now) {
      //   this.$Message.warning("开始时间不能小于当前时间");
      //   return;
      // }
      if (_endTime < _beginTime) {
        this.$Message.warning("结束时间不能小于开始时间");
        return;
      }

      // 联系人
      data.userName = that.lianxiren ? that.lianxiren : "";
      // 联系人电话
      data.phoneNO = that.dianhua ? that.dianhua : "";
      // 人数上限
      data.limitNumber = that.shangxian ? that.shangxian : "";
      // 积分
      data.score = that.jifen ? that.jifen * 100 : 0;
      // 提醒天数 默认提前一天提醒
      data.remindBefore = that.tixingId ? that.tixingId : 0;
      // data.remindBefore = 1;
      // 活动分类ID集合,
      data.labelIdList = activitytype;
      // 活动标题
      data.title = that.title ? that.title : "";
      // 活动内容
      data.context = that.actcontent ? that.actcontent : "";
      // 开始时间
      data.beginTime = that.startDate.valueOf()
        ? `${that.$util.FormatDate(that.startDate.valueOf(), "yyyy-MM-dd")} ${
            that.startTime
          }`
        : "";
      // 结束时间
      data.endTime = that.endDate.valueOf()
        ? `${that.$util.FormatDate(that.endDate.valueOf(), "yyyy-MM-dd")} ${
            that.endTime
          }`
        : "";
      // 是否发布
      data.isSend = state;
      data.voteId = that.voteId;
      // 地址
      data.address = that.zuobiao.label ? that.zuobiao.label : "";
      // 封面
      data.coverPicUrl = that.imgArr.length > 0 ? that.imgArr[0].path : "";
      // 活动时长
      data.timeLength = that.timeLength * 3600 * 1000 || "";
      // 主办方id
      data.organizerList = that.zhubanList
        .filter(item => {
          return item.id == that.zhuban;
        })
        .map(item => {
          return {
            comeId: item.id,
            comeType: item.comeType
          };
        });
      // 活动id 传值代表修改
      if (that.id != "") {
        data.id = that.id;
      }
      data.appTypeList = that.joinPeople;
      // 检测草稿的编辑内容
      if (state == 0) {
        if (
          !(
            data.coordinate ||
            data.userName ||
            data.phoneNO ||
            data.limitNumber ||
            that.jifen != "" ||
            that.tixingId ||
            data.title ||
            data.context ||
            data.beginTime ||
            data.endTime ||
            data.address ||
            data.coverPicUrl ||
            data.organizerList.length ||
            that.joinPeople.length
          )
        ) {
          this.$Message.warning("未编辑任何内容！");
          return;
        }
      }
      if (state == 0) {
        that.isSaveCaogao = true;
      } else {
        that.isSaveSend = true;
      }
      var url = that.urlobj.activitySend;
      that
        .$post(url, data)
        .then(res => {
          if(res.isSucceed){
            this.$Message.success("提交成功");
            if (state == 1) {
              that.$router.push({ name: "activitylist", query: { state: 1 } });
            } else {
              that.$router.push({ name: "activitylist", query: { state: 0 } });
            }
          }else{
            this.$Message.error(res.message);
          }
          
        })
        .catch(e => {
          if (state == 0) {
            that.isSaveCaogao = false;
          } else {
            that.isSaveSend = false;
          }
        });
    },
    // 活动默认回填数据
    getActPre() {
      let url = this.urlobj.getActPre;
      var that = this;
      this.$get(url).then(res => {
        var data = res.rows[0];
        this.zhuban = data.organizerList.length
          ? data.organizerList[0].comeId
          : "";
        this.lianxiren = data.userName;
        this.dianhua = data.phoneNO;
        this.startDate = data.beginTime
          ? this.$util.FormatDate(Number(data.beginTime), "yyyy-MM-dd")
          : "";
        this.startTime = data.beginTime
          ? this.$util.FormatDate(Number(data.beginTime), "HH:mm:ss")
          : "";
        this.jifen = data.score ? data.score / 100 : 0;
        this.joinPeople = data.appTypeList;
        this.didian = data.address;
        this.tixingId = data.remindBefore.toString();
        this.shangxian = data.limitNumber;
        if (data.coordinate) {
          var reg = /[0-9]+.[0-9]+/g;
          var xy = data.coordinate.match(reg);
          that.zuobiao.value = xy.join(",");
          that.zuobiao.label = data.address;
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.header = this.$route.query.id ? "编辑" : "新建";
    console.log(this.$store.state.apptype);
    if (this.$store.state.apptype == "ipy") {
      this.joinList[1].id = "ipy";
      this.joinList[1].name = "i濮阳";
    } else if (this.$store.state.apptype == "ctt") {
      this.joinList.splice(0, 1, {id:"ctxf", name: "丛台先锋"})
      this.joinList.splice(1, 1, {id:"ctt", name: "丛台通"})
      console.log(this.joinList)
    } else if (this.$store.state.apptype == "dxbst") {
      this.joinList=[{id:"dxxf", name: "东乡先锋"}]
      // this.joinList.splice(1, 1, {id:"dxbst", name: "东乡百事通"})
      // this.joinList[1].id = "dxbst";
      // this.joinList[1].name = "东乡百事通";
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getcaogao(this.$route.query.id);
    } else {
      this.getActPre();
    }

    if ("state" in this.$route.query) {
      this.routerState = this.$route.query.state;
    }
    this.getZhuban();
    this.getactive();

    this.getScore();
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    // 减导航栏，标题栏，上下padding
    this.editorHeight = h - 60 - 84 - 20 - 20 + "px";
    // 判断是否是从详情中来
    if ("isFromDetail" in this.$route.query) {
      this.isFromDetail = 1;
    }
    this.remoteMethod1('');
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.wrapper {
  color: #666666;
  overflow: hidden;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;

  .left {
    position: absolute;
    left: 20px;
    font-size: 35px;
    color: #999;
  }
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  /*background: #fd7c42;*/
  position: absolute;
  right: 20px;
  height: 84px;
  display: flex;
  align-items: center;
}

.editview {
  padding: 0 20px;
  width: 100%;
  align-items: flex-start;
  .editform {
    background-color: #fff;
    width: 560px;
    padding: 20px;
  }
  .editbox {
    background-color: #fff;
    padding: 20px;
    margin-left: 20px;
  }
}
.uploadbox {
  width: 520px;
  height: 325px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /*margin-bottom: 30px;*/
  .add {
    font-size: 80px;
    color: #d3d3d3;
    margin-top: 40px;
  }
  .tr1 {
    font-size: 14px;
    color: #676767;
    margin: 20px 0 60px 0;
  }
  .tr2 {
    font-size: 15px;
    color: #999;
  }
}
.editslotbox {
  width: 100%;
  padding: 15px 15px;
}
.activitytitle {
  width: 100%;
  border: none;
  resize: none;
  outline: none;
  color: #666;
  font-size: 18px;
  font-weight: bold;
}
.titlenumber {
  width: 100%;
  text-align: right;
  font-size: 14px;
  height: 14px;
  line-height: 14px;
  color: #999;
}
// .rightEdit1 {
//   margin-left: 40px;
//   margin-bottom: 80px;
// }
.active-amap {
  width: 100%;
  height: 300px;
  position: absolute;
  top: 40px;
  z-index: 999;
}

/*选择地点的样式*/
.address {
  width: 100%;
  height: 32px;
  line-height: 24px;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
}
.address_nodata {
  color: #bbb;
}
.address:hover {
  border: 1px solid #ff7b44;
}
.address:active {
  border: 1px solid #ff7b44;
}
</style>
